import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView } from "react-native";
import AppColors from "../Constants/AppColors";
import AppFonts from "../Constants/AppFonts";

/**
 * TopTabs - a state-based replacement for @react-navigation material-top-tabs.
 *
 * The app is routed by react-router and has no <NavigationContainer>, so
 * React Navigation's Tab.Navigator renders blank on web. This renders the
 * same underline tab bar without React Navigation.
 *
 *   <TopTabs
 *     tabs={[
 *       { label: "All", render: () => <AllList navigation={navigation} /> },
 *       { label: "Online", render: () => <OnlineList navigation={navigation} /> },
 *     ]}
 *   />
 */
export default function TopTabs({ tabs = [], initialIndex = 0, scrollable = false }) {
  const [active, setActive] = useState(initialIndex);
  const current = tabs[active];

  const Bar = (
    <View
      style={{
        flexDirection: "row",
        backgroundColor: AppColors.white,
        borderBottomWidth: 1,
        borderBottomColor: "#9C49001A",
      }}
    >
      {tabs.map((t, i) => {
        const focused = i === active;
        return (
          <TouchableOpacity
            key={i}
            activeOpacity={0.7}
            onPress={() => setActive(i)}
            style={{
              flex: scrollable ? undefined : 1,
              paddingHorizontal: scrollable ? 18 : 0,
              alignItems: "center",
              paddingVertical: 12,
              borderBottomWidth: 2,
              borderBottomColor: focused ? "#8F4300" : "transparent",
            }}
          >
            <Text
              style={{
                fontSize: 14,
                textAlign: "center",
                color: focused ? "#8F4300" : "#9C4900CC",
                fontFamily: focused
                  ? AppFonts.OverpassBold
                  : AppFonts.OverpassRegular,
              }}
            >
              {t.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );

  return (
    <View style={{ flex: 1 }}>
      {scrollable ? (
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={{ flexGrow: 0 }}
        >
          {Bar}
        </ScrollView>
      ) : (
        Bar
      )}
      <View style={{ flex: 1 }}>{current ? current.render() : null}</View>
    </View>
  );
}
